import React, { useMemo } from 'react'

import { Button, Dropdown, Menu, Radio, Select, Switch } from 'antd'
import { useSelector } from 'react-redux'
import { faGear } from '@fortawesome/pro-solid-svg-icons'

import { OverlaySettings } from '../../../../Components/antd/Tables/DragTable/OverlaySettings'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import OverlaySettingsDropdown from './OverlaySettingsDropdown'
import { TIME_PERIODS } from '../../../../utils/timePeriods'
import { Properties } from '../../../../utils/entities'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

const { Option } = Select

const QuotasTableSettings = ({
  coloredEntity, overlayPrefix, visible, overlayMenuVisible, period, overlaySettings = new OverlaySettings(), isYearly,
  onColoredEntityChange, onClick, onPeriodChange, onVisibleChange, onOverlayMenuVisibleChange, onOverlaySettingsSelection, onIsYearlyChange, onResetGravity
}) => {
  const t = useSelector(selectTranslate)

  const periods = useMemo(() => TIME_PERIODS.map((option, index) => (
    <Option key={index} value={option.quantity}>
      {t(option.text)}
    </Option>
  )), [t])

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      onVisibleChange={onVisibleChange}
      onClick={onClick}
      overlay={(
        <Menu>
          <Menu.ItemGroup title={t('common.period')}>
            <Menu.Item>
              <Select
                className='w-100 j-ctn-s mt-4'
                value={period.quantity}
                onChange={onPeriodChange}
              >
                {periods}
              </Select>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.overlay')}>
            <Menu.Item>
              <OverlaySettingsDropdown
                className='w-100 j-ctn-s mt-4'
                prefix={overlayPrefix}
                visible={overlayMenuVisible}
                onVisibleChange={onOverlayMenuVisibleChange}
                onClick={onOverlayMenuVisibleChange}
                settings={overlaySettings}
                onSelection={onOverlaySettingsSelection}
              />
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.is_yearly')}>
            <Menu.Item onClick={() => onIsYearlyChange(isChecked => !isChecked)}>
              <Switch checked={isYearly} />
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.show_colors')}>
            <Menu.Item>
              <Radio.Group onChange={e => onColoredEntityChange(e.target.value)} value={coloredEntity}>
                <Radio value={Properties.SCHOOL}>
                  {t('common.by_school')}
                </Radio>
                <Radio value={Properties.SECTION_TO_YEAR}>
                  {t('common.by_section')}
                </Radio>
              </Radio.Group>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup title={t('common.reset_gravity')}>
            <Menu.Item onClick={onResetGravity}>
              <Button> {t('common.reset')} </Button>
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu>
      )}
    >
      <IconButton
        icon={faGear}
        type={isYearly ? 'primary' : 'default'}
        text={t('school_quota_view.dropdowns.configure_table')}
      />
    </Dropdown>
  )
}

export default QuotasTableSettings
